import './dependencies.js';

import { mountApp } from '@/services/config.js';
import { trackRoomClicked } from '@/services/room-interactions-tracker';

import EnquiryFormWrapper from './EnquiryFormWrapper.vue';
import store from './store/index.js';

$(() => {
  mountApp(EnquiryFormWrapper, '#app', [store]);
});

// GA4 Roompage tracking
$('[data-track="click"]').on('click', (e) => {
  const $target = $(e.currentTarget);
  const section = $target.data('track-section');
  const element = $target.data('track-element');
  const value = $target.data('track-value');

  App.track.event('room_page_interaction', {
    ...store.getters.ga4ParamsBase(),
    section,
    element,
    interaction: 'click',
    element_value: value ?? null,
  });
});

$.subscribe('room_page_interaction', (params) => {
  const pricingsLiquidityIndicators = store.state.pricingsLiquidityIndicators ?? null;
  if (params?.section === 'prices' && pricingsLiquidityIndicators) {
    params = Object.assign(params, {
      exp_pricing_update: pricingsLiquidityIndicators?.inExperiment && pricingsLiquidityIndicators?.lastUpdateInDays ? 'Yes' : 'No',
      exp_pricing_update_value: pricingsLiquidityIndicators?.lastUpdateInDays ?? null,
      exp_pricing_confirmation: pricingsLiquidityIndicators?.inExperiment && pricingsLiquidityIndicators?.lastUpdateConfirmations ? 'Yes' : 'No',
      exp_pricing_confirmation_value: pricingsLiquidityIndicators?.lastUpdateConfirmations ?? null,
    });
  }

  App.track.event('room_page_interaction', {
    ...store.getters.ga4ParamsBase(),
    ...params,
  });
});

const onRoomCardClick = (e, section) => {
  const $target = $(e.currentTarget);
  const id = $target.data('id');
  const venueId = $target.data('venue-id');
  const index = $target.data('index');

  if (e.target.className.includes('c-room-card__heart') || e.target.className.includes('arrow')) { // heart clicked
    return;
  }

  trackRoomClicked(+id);

  App.track.event('clicked_to_room_page', {
    ...store.getters.ga4ParamsBase(),

    section,
    element: 'room_tile',
    element_value: id,

    room_id: id,
    venue_id: venueId,
    position: (+index + 1),

    interaction: 'click',
  });
};

$(document).on('click', '[data-name="Similar Rooms"] .c-room-card', (e) => {
  onRoomCardClick(e, 'room_page_recommended_carousel');
});
$(document).on('click', '.p-room-other-rooms .c-room-card', (e) => {
  onRoomCardClick(e, 'room_page_other_rooms');
});
